import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

// interface ActivePuzzle {
//   puzzle_name: string;
//   move_count: number;
//   starting_fen: string;
//   created_by: string;
//   created_at: string;
// }

interface ClassroomInfoPayload {
  meetingId: string;
  userId: string;
  occurenceId: string;
  meetingRole: string;
}

// interface ClassroomInfoResponse {
//   signature: string;
//   role: number;
//   activePuzzle: ActivePuzzle;
// }

export default function useClassroomInfoApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, ClassroomInfoPayload> {
  return useMutation<any, unknown, ClassroomInfoPayload>(
    async (payload: ClassroomInfoPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_classroom_details/',
        payload,
      );
      console.log('Retrieved Classroom Info = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch Classroom meeting data:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
